import React, { useEffect, useState } from 'react';
import { ExaminationResults } from './examination-results';
import { IncludedExamResults } from './included-exam-result';
import { useTranslation } from 'react-i18next';
export const StudentResults = ({ student, language, studentBaseUrl }) => {
    var _a;
    const [exams, setExams] = useState({});
    const [totalGradePoints, setTotalGradePoints] = useState();
    useEffect(() => {
        const addIncludedExamPoints = (gradePoints, examsWithBestGrades) => {
            if (!student.includedExams) {
                return gradePoints;
            }
            return student.includedExams
                .filter(exam => {
                const examUuidsWithBestGrades = examsWithBestGrades.map(exam => exam.examUuid);
                return !examUuidsWithBestGrades.includes(exam.examUuid);
            })
                .reduce((total, exam) => exam.details[0].gradePoints + total, gradePoints);
        };
        const examsWithBestGrades = student.exams.filter(exam => exam.isBestGrade);
        const calculatedGradePoints = examsWithBestGrades.reduce((total, exam) => exam.gradePoints + total, 0);
        setTotalGradePoints(addIncludedExamPoints(calculatedGradePoints, examsWithBestGrades));
        setExams(groupExams(student.exams));
    }, [student]);
    const studentName = (React.createElement("span", null,
        React.createElement("strong", null, student.name.lastname),
        " ",
        student.name.firstname));
    return (React.createElement("div", { className: "student-exam-results" },
        React.createElement("h2", { className: "header" },
            studentBaseUrl && student.studentUuid ? (React.createElement("a", { href: `${studentBaseUrl}${student.studentUuid}` }, studentName)) : (studentName),
            student.ssn && React.createElement("span", { className: "ssn" }, student.ssn),
            React.createElement("span", { className: student.ssn ? 'birthday' : 'birthday no-ssn' }, student.birthday),
            React.createElement("span", { className: "statements" },
                React.createElement("em", null, getStatements(student))),
            React.createElement("span", { className: "total-grade-points" }, totalGradePoints)),
        Object.keys(exams).map(examinationcode => (React.createElement(ExaminationResults, { key: examinationcode, exams: exams[examinationcode], examinationcode: examinationcode, language: language, isLaw2022Student: student.isLaw2022Student, studentTechnicalErrors: student.technicalErrors }))),
        ((_a = student.includedExams) === null || _a === void 0 ? void 0 : _a.length) ? (React.createElement(IncludedExamResults, { includedExams: student.includedExams, language: language })) : null));
};
const getStatements = (student) => {
    const { t } = useTranslation();
    const statements = [];
    if (student.dyslexias.length > 0) {
        statements.push(t('results.dyslexia'));
    }
    if (student.statements.length > 0) {
        statements.push(t('results.statement'));
    }
    return statements.map((Statement, index) => index === statements.length - 1 ? React.createElement("span", { key: index }, Statement) : React.createElement("span", { key: index },
        Statement,
        ", "));
};
const groupExams = (exams) => {
    exams.sort((a, b) => b.examinationcode.localeCompare(a.examinationcode));
    const groupedExams = exams.reduce((result, exam) => {
        if (result[exam.examinationcode]) {
            result[exam.examinationcode].push(exam);
        }
        else {
            result[exam.examinationcode] = [exam];
        }
        return result;
    }, {});
    Object.keys(groupedExams).forEach(examinationcode => {
        groupedExams[examinationcode].sort((a, b) => {
            if (Boolean(a.questionScores) === Boolean(b.questionScores)) {
                return a.nameFinnish.localeCompare(b.nameFinnish, 'fi');
            }
            return a.questionScores ? -1 : 1;
        });
    });
    return groupedExams;
};
//# sourceMappingURL=student-result.js.map